import React from 'react'
import styled from 'styled-components'
import { toast } from 'react-toastify'
import { redirect } from 'utils/paths'

const ActionToast = ({ message, actionLabel, onAction, closeToast }) => (
  <Wrap>
    <span>{message}</span>
    {actionLabel && (
      <ActionBtn
        type='button'
        onClick={e => {
          e.stopPropagation()
          closeToast?.()
          onAction?.()
        }}
      >
        {actionLabel}
      </ActionBtn>
    )}
  </Wrap>
)

export const toastWithAction = (tone, message, actionLabel, onAction, options = {}) =>
  (toast[tone] || toast)(
    props => <ActionToast {...props} message={message} actionLabel={actionLabel} onAction={onAction} />,
    { autoClose: 8000, ...options }
  )

export const toastWithLink = (tone, message, actionLabel, path, options = {}) =>
  toastWithAction(tone, message, actionLabel, () => redirect(path), options)

export default ActionToast

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`

const ActionBtn = styled.button`
  font: inherit;
  min-height: 36px;
  padding: 6px 12px;
  border: 1px solid currentColor;
  border-radius: 8px;
  background: #fff;
  color: #1f7f89;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  &:hover { background: #e6f7f9; }
  &:focus-visible { outline: 2px solid #33becc; outline-offset: 2px; }
`
